module.exports = __webpack_public_path__ + "static/media/code-the-change.78593c03.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/img/logos/code-the-change.png
// module id = 359
// module chunks = 0